module.exports = __webpack_public_path__ + "img/ic_close.6e1e5b38.svg";